<template>
  <div class="top-bar">
    <div class="top-bar-inner">
      <div class="top-bar-right" v-if="!isLoggedIn">
        <div class="auth-links">
          <i class="el-icon-user auth-icon"></i>
          <span class="auth-link" @click="openLogin">Log in</span>
          <span class="auth-divider">or</span>
          <span class="auth-link" @click="openSignup">Sign Up</span>
        </div>
        <div class="cart-link" @click="$router.push({ name: 'cart' })">
          <img class="cart-icon" src="@/assets/cart1.png" alt="cart">
          <span>Cart is empty</span>
        </div>
      </div>

      <div class="top-bar-right logged-links" v-else>
        <button class="plain-link" type="button" @click="$router.push({ name: 'inquiries' })">Quotation Request</button>
        <button class="plain-link" type="button" @click="$router.push({ name: 'orders' })">orders</button>
        <div class="profile-menu">
          <button class="profile-trigger" type="button">
            <i class="el-icon-user"></i>
            <span>Profile</span>
            <i class="el-icon-arrow-down arrow"></i>
          </button>
          <div class="profile-dropdown">
            <div class="hello">Hi, {{ userInfo.name || userInfo.email }}!</div>
            <button type="button" @click="$router.push({ name: 'account-settings' })">Account Settings</button>
            <div class="dropdown-divider"></div>
            <button type="button" @click="logout">Log Out</button>
          </div>
        </div>
        <button class="mail-btn" type="button" @click="$router.push({ name: 'inquiries' })">
          <i class="el-icon-message"></i>
        </button>
        <div class="cart-link logged-cart" @click="$router.push({ name: 'cart' })">
          <div class="cart-icon-wrap">
            <img class="cart-icon" src="@/assets/cart1.png" alt="cart">
            <span v-if="userInfo.cart_item_count > 0" class="cart-badge">{{ userInfo.cart_item_count }}</span>
          </div>
          <span v-if="userInfo.cart_item_count == 0">Cart is empty</span>
        </div>
      </div>
    </div>

    <LoginModal :visible="showModal" :activeTab="activeTab" @update:activeTab="activeTab = $event"
      @success="handleLoginSuccess" @close="closeModal" />
  </div>
</template>

<script>
import LoginModal from './LoginModal.vue'
import { getToken, removeToken } from '@/util/token-util.js'

export default {
  name: 'TopBar',
  components: {
    LoginModal
  },
  data() {
    return {
      showModal: false,
      activeTab: 'login',
      isLoggedIn: false,
      cartCount: 0,
      userInfo: {}
    }
  },
  mounted() {
    if (getToken()) {
      this.isLoggedIn = true
      this.loadUserInfo()
      this.loadCartCount()
    }
    this.$root.$on('cart-updated', this.onCartUpdated)
  },
  beforeDestroy() {
    this.$root.$off('cart-updated', this.onCartUpdated)
  },
  methods: {
    openLogin() {
      this.activeTab = 'login'
      this.showModal = true
    },
    openSignup() {
      this.activeTab = 'signup'
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    loadUserInfo() {
      return this.$api({
        url: 'User/info',
        method: 'get'
      }).then(res => {
        this.userInfo = res.data || {}
      }).catch(() => {
        // ignore - user info may fail if token expired
      })
    },
    loadCartCount() {
      this.$api({
        url: 'Cart/list',
        method: 'get'
      }).then(res => {
        const list = res.data || []
        this.cartCount = Array.isArray(list) ? list.length : 0
      }).catch(() => {
        this.cartCount = 0
      })
    },
    handleLoginSuccess() {
      this.isLoggedIn = true
      this.closeModal()
      this.loadUserInfo()
      this.loadCartCount()
    },
    onCartUpdated() {
      this.loadUserInfo()
      this.loadCartCount()
    },
    logout() {
      this.$api({
        url: 'User/logout',
        method: 'post'
      }).catch(() => {
        // still logout on failure
      }).finally(() => {
        removeToken()
        this.isLoggedIn = false
        this.userInfo = {}
        this.cartCount = 0
        this.$router.push({ name: 'home' })
      })
    }
  }
}
</script>

<style scoped>
.top-bar {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.top-bar-inner {
  max-width: 1100px;
  height: 43px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.top-bar-right {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 28px;
}

.auth-links,
.cart-link {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1;
}

.auth-icon,
.auth-link,
.plain-link,
.profile-trigger,
.mail-btn,
.profile-dropdown button {
  color: #F34B01;
}

.auth-icon {
  font-size: 14px;
}

.auth-link {
  cursor: pointer;
  text-decoration: none;
}

.auth-link:hover,
.plain-link:hover,
.profile-dropdown button:hover {
  text-decoration: underline;
}

.auth-divider,
.cart-link {
  color: #999;
}

.cart-link {
  cursor: pointer;
}

.cart-icon {
  width: 18px;
  height: 18px;
  color: #b5b5b5;
  font-size: 15px;
}

.cart-icon-wrap {
  position: relative;
  display: inline-flex;
}

.cart-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #F34B01;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
}

.cart-link:hover,
.cart-link:hover .cart-icon {
  color: #F34B01;
}

/* 未登录时购物车图标置灰 */
.cart-link:not(.logged-cart) .cart-icon {
  filter: grayscale(1);
  opacity: 0.5;
}

.logged-links {
  gap: 0;
}

.plain-link,
.profile-trigger,
.mail-btn {
  height: 32px;
  border: 0;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
}

.plain-link {
  padding: 0 18px;
}

.profile-menu {
  height: 32px;
  position: relative;
}

.profile-trigger {
  min-width: 132px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  font-size: 14px;
}

.profile-trigger .el-icon-user {
  font-size: 22px;
}

.profile-trigger .arrow {
  font-size: 14px;
}

.profile-dropdown {
  position: absolute;
  top: 32px;
  left: 0;
  z-index: 20;
  width: 200px;
  padding: 4px 20px 6px;
  background: #fff;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.08);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.16s, transform 0.16s, visibility 0.16s;
}

.profile-menu:hover .profile-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.hello {
  margin-bottom: 2px;
  color: #555;
  font-size: 14px;
  line-height: 1.2;
}

.profile-dropdown button {
  display: block;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  padding: 2px 0;
}

.dropdown-divider {
  height: 1px;
  margin: 4px 0 4px;
  background: #f0f0f0;
}

.mail-btn {
  width: 58px;
  border-right: 1px solid #eee;
  font-size: 14px;
}

.logged-cart {
  height: 32px;
  padding-left: 22px;
  font-size: 14px;
}

.logged-cart .cart-icon {
  font-size: 22px;
}
</style>
